export function getDescription(requirement, basket_name) {
  return `Skipping this action will create a task "${
    requirement.task_title || requirement.name
  }" in the “${basket_name}” task basket for review.`
}
